"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("@hapi/joi"));
const Time = __importStar(require("@sellout/utils/.dist/time"));
const IEvent_1 = require("../interfaces/IEvent");
const CustomFieldTypeEnum_1 = require("../enums/CustomFieldTypeEnum");
const DropDownEnum_1 = require("../enums/DropDownEnum");
const IEvent_2 = require("../interfaces/IEvent");
exports.default = {
    /****************************************************************************************
     * Schedule
     ****************************************************************************************/
    hasBeenAnnounced(event) {
        const { schedule: { announceAt }, } = event;
        const now = Time.now();
        return announceAt < now;
    },
    isAnnounced(event) {
        const { schedule: { announceAt, ticketsAt }, } = event;
        const now = Time.now();
        return announceAt < now && now < ticketsAt;
    },
    isOnSale(event) {
        var _a, _b;
        const ticketsAt = (_a = event === null || event === void 0 ? void 0 : event.schedule) === null || _a === void 0 ? void 0 : _a.ticketsAt;
        const ticketsEndAt = (_b = event === null || event === void 0 ? void 0 : event.schedule) === null || _b === void 0 ? void 0 : _b.ticketsEndAt;
        const now = Time.now();
        return ticketsAt < now && now < ticketsEndAt;
    },
    isInProgress(event) {
        const { schedule: { startsAt, endsAt }, } = event;
        const now = Time.now();
        return startsAt < now && now < endsAt;
    },
    saleHasEnded(event) {
        const { schedule: { ticketsEndAt }, } = event;
        const now = Time.now();
        return ticketsEndAt < now;
    },
    isSoldOut(event) {
        return this.remainingTicketQty(event) > 0;
    },
    hasEnded(event) {
        const { schedule: { endsAt }, } = event;
        const now = Time.now();
        return endsAt < now;
    },
    isUnavailable(event) {
        if (!event.published)
            return true;
        if (!this.hasBeenAnnounced(event))
            return true;
        if (!this.isOnSale(event))
            return true;
        if (this.allTicketsAreLocked(event))
            return true;
        if (this.saleHasEnded(event))
            return true;
        return false;
    },
    allTicketsAreLocked(event) {
        var _a, _b;
        const ticketTypeCount = (_a = event.ticketTypes) === null || _a === void 0 ? void 0 : _a.length;
        const promotionCodeTicketCount = [
            ...new Set((_b = event.promotions) === null || _b === void 0 ? void 0 : _b.filter((a) => a.type === "Unlock" && a.active).reduce((cur, promotion) => {
                // (this.isOnSale(event) ? promotion.type === "Unlock" : (promotion.type === "Presale" || promotion.type === "Unlock"))
                // if(2!==2)
                return [...cur, ...promotion.ticketTypeIds];
            }, [])),
        ].length;
        return ticketTypeCount === promotionCodeTicketCount;
    },
    /****************************************************************************************
     * QR Code
     ****************************************************************************************/
    qrCodeEmailAt(event) {
        const { performances: [performance], } = event;
        const { schedule } = performance;
        // let doorsAt = schedule[0].doorsAt;
        let startsAt = schedule[0].startsAt;
        /*const {
          schedule: { doorsAt, startsAt },
        } = performance;
        console.log
            changing to lower case
            becuse previosly it is stored with different values
            like Upon Order, Upon order
        */
        if (event.sendQRCode.toLowerCase() === IEvent_2.SendQRCodeEnum.UponOrder.toLowerCase()) {
            return Time.now();
        }
        if (event.sendQRCode.toLowerCase() ===
            IEvent_2.SendQRCodeEnum.TwoWeeksBefore.toLowerCase()) {
            const TWO_WEEKS = 14 * 24 * 60 * 60;
            return startsAt - TWO_WEEKS;
        }
        // if (
        //   event.sendQRCode.toLowerCase() ===
        //   SendQRCodeEnum.DayOfShow.toLowerCase()
        // ) {
        //   const TWO_WEEKS = 14 * 24 * 60 * 60;
        //   return startsAt - TWO_WEEKS;
        // }
        /* if (event.sendQRCode === "Upon Order") {
            return Time.now();
        }
    
        if (event.sendQRCode === "Two Weeks Before Show") {
          const TWO_WEEKS = 14 * 24 * 60 * 60;
          return startsAt - TWO_WEEKS;
        } */
        // return doorsAt - 600;
        return startsAt - 28800;
    },
    shouldSendOrderReceipt(event) {
        const now = Time.now();
        const qrCodeEmailAt = this.qrCodeEmailAt(event);
        // Never send a receipt if we are
        // send a qr code upon order
        if (event.sendQRCode.toLowerCase() === IEvent_2.SendQRCodeEnum.UponOrder.toLowerCase()) {
            return false;
        }
        // if (event.sendQRCode === "Upon Order") {
        //   return false;
        // }
        // Only send a receipt if QR codes for
        // the event haven't already gone out
        if (qrCodeEmailAt > now) {
            return true;
        }
        return false;
    },
    /****************************************************************************************
     * Process As
     ****************************************************************************************/
    isPaid(event) {
        return (event === null || event === void 0 ? void 0 : event.processAs) === IEvent_1.EventProcessAsEnum.Paid;
    },
    isRSVP(event) {
        return (event === null || event === void 0 ? void 0 : event.processAs) === IEvent_1.EventProcessAsEnum.RSVP;
    },
    // isFree(event: IEvent): boolean {
    //   return event.processAs === EventProcessAsEnum.Free;
    // },
    /****************************************************************************************
     * Seating
     ****************************************************************************************/
    isSeated(event) {
        if (!event)
            return false;
        return Boolean(event.seatingChartKey);
    },
    /****************************************************************************************
     * Venue
     ****************************************************************************************/
    venueIds(event) {
        let venueIds = [event.venueId];
        event.performances.forEach((performance) => {
            venueIds = venueIds.concat(performance.venueStageId);
        });
        venueIds = [...new Set(venueIds)];
        venueIds = venueIds.filter((v) => !!v);
        return venueIds;
    },
    seatingId(event) {
        return event._id.replace("_", "SAMH");
    },
    /****************************************************************************************
     * Artist
     ****************************************************************************************/
    artistIds(event) {
        let artistIds = [];
        event.performances.forEach((performance) => {
            artistIds = artistIds
                .concat(performance.headliningArtistIds)
                .concat(performance.openingArtistIds);
        });
        artistIds = [...new Set(artistIds)];
        artistIds = artistIds.filter((a) => !!a);
        return artistIds;
    },
    headliningArtistIds(event) {
        let artistIds = [];
        event.performances.forEach((performance) => {
            artistIds = artistIds.concat(performance.headliningArtistIds);
        });
        artistIds = [...new Set(artistIds)];
        artistIds = artistIds.filter((a) => !!a);
        return artistIds;
    },
    openingArtistIds(event) {
        let artistIds = [];
        event.performances.forEach((performance) => {
            artistIds = artistIds.concat(performance.openingArtistIds);
        });
        artistIds = [...new Set(artistIds)];
        artistIds = artistIds.filter((a) => !!a);
        return artistIds;
    },
    /****************************************************************************************
     * Tickets Hold
     ****************************************************************************************/
    ticketHold(event, ticketHoldId) {
        return event === null || event === void 0 ? void 0 : event.holds.find((ticketHold) => ticketHold._id === ticketHoldId);
    },
    /****************************************************************************************
     * Guest List
     ****************************************************************************************/
    plainGuestEntry(value) {
        return value && typeof value.toObject === "function"
            ? value.toObject()
            : value;
    },
    guestListSessions(event) {
        var _a, _b, _c, _d, _e, _f;
        const scheduled = ((_c = (_b = (_a = event === null || event === void 0 ? void 0 : event.performances) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.schedule) !== null && _c !== void 0 ? _c : [])
            .filter((day) => Boolean(day === null || day === void 0 ? void 0 : day.startsAt))
            .map((day) => {
            var _a;
            return ({
                startsAt: day.startsAt,
                endsAt: (_a = day === null || day === void 0 ? void 0 : day.endsAt) !== null && _a !== void 0 ? _a : null,
            });
        });
        if (scheduled.length) {
            const byStart = new Map();
            scheduled.forEach(({ startsAt, endsAt }) => {
                var _a;
                if (!byStart.has(startsAt)) {
                    byStart.set(startsAt, endsAt);
                    return;
                }
                const current = (_a = byStart.get(startsAt)) !== null && _a !== void 0 ? _a : null;
                if (current === null || endsAt === null)
                    return;
                byStart.set(startsAt, Math.max(current, endsAt));
            });
            return Array.from(byStart.entries())
                .map(([startsAt, endsAt]) => ({ startsAt, endsAt }))
                .sort((a, b) => a.startsAt - b.startsAt);
        }
        return ((_d = event === null || event === void 0 ? void 0 : event.schedule) === null || _d === void 0 ? void 0 : _d.startsAt)
            ? [
                {
                    startsAt: event.schedule.startsAt,
                    endsAt: (_f = (_e = event === null || event === void 0 ? void 0 : event.schedule) === null || _e === void 0 ? void 0 : _e.endsAt) !== null && _f !== void 0 ? _f : null,
                },
            ]
            : [];
    },
    GUEST_LIST_MAX_GROUP_SIZE: 100,
    guestListHighestNumber(guestList, firstName, lastName) {
        const normalize = (value) => (value !== null && value !== void 0 ? value : "").trim().toLowerCase();
        const escaped = normalize(lastName).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const pattern = new RegExp(`^${escaped}(?: \\((\\d+)\\))?$`);
        return (guestList !== null && guestList !== void 0 ? guestList : []).reduce((highest, entry) => {
            if (normalize(entry.firstName) !== normalize(firstName))
                return highest;
            const match = normalize(entry.lastName).match(pattern);
            if (!match)
                return highest;
            return Math.max(highest, match[1] ? parseInt(match[1], 10) : 1);
        }, 0);
    },
    guestListRenumberOnDelete(guestList, guestListEntryId) {
        const removed = (guestList !== null && guestList !== void 0 ? guestList : []).find((g) => g._id === guestListEntryId);
        if (!removed)
            return [];
        const numberPattern = / \((\d+)\)$/;
        const base = (lastName) => (lastName !== null && lastName !== void 0 ? lastName : "").replace(numberPattern, "");
        const numberOf = (lastName) => {
            const match = (lastName !== null && lastName !== void 0 ? lastName : "").match(numberPattern);
            return match ? parseInt(match[1], 10) : 1;
        };
        const normalize = (value) => (value !== null && value !== void 0 ? value : "").trim().toLowerCase();
        const sameGroup = (g) => normalize(g.firstName) === normalize(removed.firstName) &&
            normalize(base(g.lastName)) === normalize(base(removed.lastName));
        const removedNumber = numberOf(removed.lastName);
        return guestList
            .filter((g) => g._id !== guestListEntryId &&
            sameGroup(g) &&
            numberOf(g.lastName) > removedNumber)
            .map((g) => ({
            _id: g._id,
            lastName: `${base(g.lastName)} (${numberOf(g.lastName) - 1})`,
        }));
    },
    guestListDays(event) {
        return this.guestListSessions(event).map((session) => session.startsAt);
    },
    syncGuestListDays(event) {
        var _a;
        const guestList = (_a = event === null || event === void 0 ? void 0 : event.guestList) !== null && _a !== void 0 ? _a : [];
        if (!guestList.length)
            return guestList;
        const days = this.guestListDays(event);
        if (!days.length)
            return guestList;
        const isCurrentDay = new Set(days);
        return guestList.map((hydrated) => {
            var _a;
            const entry = this.plainGuestEntry(hydrated);
            const existing = ((_a = entry === null || entry === void 0 ? void 0 : entry.checkIns) !== null && _a !== void 0 ? _a : []).map((checkIn) => this.plainGuestEntry(checkIn));
            const byDay = new Map(existing.map((checkIn) => [checkIn.startsAt, checkIn]));
            const current = days.map((startsAt) => {
                var _a;
                return (_a = byDay.get(startsAt)) !== null && _a !== void 0 ? _a : {
                    startsAt,
                    checkedIn: false,
                    checkedInAt: null,
                    checkedInBy: null,
                };
            });
            const attended = existing.filter((checkIn) => checkIn.checkedIn && !isCurrentDay.has(checkIn.startsAt));
            return Object.assign(Object.assign({}, entry), { checkIns: [...current, ...attended].sort((a, b) => a.startsAt - b.startsAt) });
        });
    },
    shiftGuestListDays(event, timeDelta) {
        var _a;
        return ((_a = event === null || event === void 0 ? void 0 : event.guestList) !== null && _a !== void 0 ? _a : []).map((hydrated) => {
            var _a;
            const entry = this.plainGuestEntry(hydrated);
            return Object.assign(Object.assign({}, entry), { checkIns: ((_a = entry === null || entry === void 0 ? void 0 : entry.checkIns) !== null && _a !== void 0 ? _a : []).map((checkIn) => (Object.assign(Object.assign({}, this.plainGuestEntry(checkIn)), { startsAt: checkIn.startsAt + timeDelta }))) });
        });
    },
    currentGuestListDay(event, timezone, at = Time.now()) {
        const day = (seconds) => Time.format(seconds, "YYYY-MM-DD", timezone);
        const today = day(at);
        const sessions = this.guestListSessions(event);
        const running = sessions.find((session) => session.endsAt !== null &&
            session.startsAt <= at &&
            at < session.endsAt);
        if (running)
            return running.startsAt;
        const scheduledToday = sessions.find((session) => day(session.startsAt) === today);
        return scheduledToday ? scheduledToday.startsAt : null;
    },
    /****************************************************************************************
     * Tickets
     ****************************************************************************************/
    ticketType(event, ticketTypeId) {
        return event === null || event === void 0 ? void 0 : event.ticketTypes.find((ticketType) => ticketType._id === ticketTypeId);
    },
    activeTicketTypes(event) {
        var _a, _b;
        return (_b = (_a = event === null || event === void 0 ? void 0 : event.ticketTypes) === null || _a === void 0 ? void 0 : _a.filter((ticketType) => ticketType.visible)) !== null && _b !== void 0 ? _b : [];
    },
    remainingTicketQty(event, ticketTypeId = null) {
        if (ticketTypeId) {
            let ticketType = event === null || event === void 0 ? void 0 : event.ticketTypes.find((ticketType) => ticketType._id === ticketTypeId);
            if (!ticketType)
                return 0;
            else
                return ticketType.remainingQty;
        }
        else {
            return event === null || event === void 0 ? void 0 : event.ticketTypes.reduce((cur, next) => {
                return cur + next.remainingQty;
            }, 0);
        }
    },
    remainingQtyByTicketTypes(event) {
        return event.ticketTypes.reduce((cur, ticketType) => {
            cur[ticketType._id] = this.remainingTicketQty(event, ticketType._id);
            return cur;
        }, {});
    },
    purchaseLimitByTicketTypes(event) {
        return event.ticketTypes.reduce((cur, ticketType) => {
            cur[ticketType._id] = ticketType.purchaseLimit;
            return cur;
        }, {});
    },
    getCurrentTierId(event, ticketTypeId) {
        const ticketType = event.ticketTypes.find((t) => t._id.toString() === ticketTypeId);
        const now = Time.now();
        const tier = ticketType.tiers.find((tier) => tier.startsAt < now && now < tier.endsAt);
        return tier._id;
    },
    /****************************************************************************************
     * Upgrades
     ****************************************************************************************/
    upgrade(event, upgradeId) {
        return event.upgrades.find((upgrades) => upgrades._id === upgradeId);
    },
    activeUpgrades(event) {
        var _a;
        return (((_a = event === null || event === void 0 ? void 0 : event.upgrades) !== null && _a !== void 0 ? _a : [])
            // must be active
            .filter((upgrade) => upgrade.visible)
        // must have remaining qty
        //.filter((upgrade) => upgrade.remainingQty > 0)
        );
    },
    activeNonComplimentaryUpgrades(event) {
        return (this.activeUpgrades(event)
            // must not be complimentary
            .filter((upgrade) => !upgrade.complimentary));
    },
    remainingUpgradeQty(event, upgradeId = null) {
        if (upgradeId) {
            let upgrade = event.upgrades.find((upgrade) => upgrade._id === upgradeId);
            if (!upgrade)
                return 0;
            else
                return upgrade.remainingQty;
        }
        else {
            return event.upgrades.reduce((cur, next) => {
                return cur + next.remainingQty;
            }, 0);
        }
    },
    remainingQtyByUpgrades(event) {
        return event.upgrades.reduce((cur, upgrade) => {
            cur[upgrade._id] = this.remainingUpgradeQty(event, upgrade._id);
            return cur;
        }, {});
    },
    purchaseLimitByUpgrades(event) {
        return event.upgrades.reduce((cur, upgrade) => {
            cur[upgrade._id] = upgrade.purchaseLimit;
            return cur;
        }, {});
    },
    isUpgradeForSpecificTickets(event, upgrade) {
        var _a, _b;
        return Boolean(((_a = event === null || event === void 0 ? void 0 : event.ticketTypes) === null || _a === void 0 ? void 0 : _a.map((t) => t._id).sort()) ===
            ((_b = upgrade === null || upgrade === void 0 ? void 0 : upgrade.ticketTypeIds) === null || _b === void 0 ? void 0 : _b.sort()));
    },
    /****************************************************************************************
     * Promotions
     ****************************************************************************************/
    promotion(event, promotionId) {
        return event.promotions.find((promotions) => promotions._id === promotionId);
    },
    activePromotions(event, type = null) {
        var _a;
        const now = Time.now();
        let promotions = ((_a = event === null || event === void 0 ? void 0 : event.promotions) !== null && _a !== void 0 ? _a : [])
            // must be active
            .filter((promotion) => promotion.active)
            // must have remaining qty
            .filter((promotion) => promotion.remainingQty > 0)
            // must be in the correct time
            .filter((promotion) => promotion.startsAt < now && now < promotion.endsAt);
        // Optional type
        if (type !== null) {
            promotions = promotions.filter((promotion) => promotion.type === type);
        }
        return promotions;
    },
    /****************************************************************************************
     * Custom Fields
     ****************************************************************************************/
    customField(event, customFieldId) {
        var _a, _b;
        return ((_b = (_a = event === null || event === void 0 ? void 0 : event.customFields) === null || _a === void 0 ? void 0 : _a.find((customField) => customField._id === customFieldId)) !== null && _b !== void 0 ? _b : null);
    },
    activeCustomFields(event) {
        var _a, _b;
        return ((_b = (_a = event === null || event === void 0 ? void 0 : event.customFields) === null || _a === void 0 ? void 0 : _a.filter((customField) => customField.active)) !== null && _b !== void 0 ? _b : []);
    },
    hasCustomFields(event) {
        return ((event === null || event === void 0 ? void 0 : event.customFields.filter((customField) => customField.active).length) > 0);
    },
    // Fixed issue SELLOUT-49
    customFieldsAreValid(eventCustomFields, orderCustomFields) {
        var _a, _b;
        const activeFields = (_a = eventCustomFields === null || eventCustomFields === void 0 ? void 0 : eventCustomFields.filter((eventCustomField) => eventCustomField.active)) !== null && _a !== void 0 ? _a : [];
        const validFields = (_b = activeFields === null || activeFields === void 0 ? void 0 : activeFields.filter((eventCustomField) => {
            const { _id, minLength, maxLength, minValue, maxValue, required } = eventCustomField;
            const orderCustomField = orderCustomFields === null || orderCustomFields === void 0 ? void 0 : orderCustomFields.find((orderCustomField) => orderCustomField.customFieldId === _id);
            // Field is not required and orderCustomField not empty
            if (!required && !orderCustomField)
                return true;
            // Field has not been filled out
            if (!orderCustomField)
                return false;
            let { value } = orderCustomField;
            if (!required &&
                (value === undefined ||
                    value === "NaN" ||
                    value === "" ||
                    value === DropDownEnum_1.DropDownEnum.Select)) {
                return true;
            }
            if ((eventCustomField === null || eventCustomField === void 0 ? void 0 : eventCustomField.type) === CustomFieldTypeEnum_1.CustomFieldTypeEnum.Text) {
                value = value;
                if (value) {
                    if (minLength === 0 && maxLength === 0 && value.length > 0) {
                        return true;
                    }
                    else if (minLength === 0 && value.length <= maxLength) {
                        return true;
                    }
                    else if (maxLength === 0 && minLength <= value.length) {
                        return true;
                    }
                    else if (minLength <= value.length && value.length <= maxLength) {
                        return true;
                    }
                }
                return false;
            }
            else if (eventCustomField.type === CustomFieldTypeEnum_1.CustomFieldTypeEnum.Dropdown) {
                value = value;
                if (value !== "" && value !== DropDownEnum_1.DropDownEnum.Select) {
                    return true;
                }
                return false;
            }
            else if (eventCustomField.type === CustomFieldTypeEnum_1.CustomFieldTypeEnum.Address) {
                value = value;
                if (value !== "") {
                    return true;
                }
                return false;
            }
            else {
                value = value;
                if (value) {
                    if (minValue === 0 && maxValue === 0 && value > 0) {
                        return true;
                    }
                    else if (minValue === 0 && value <= maxValue) {
                        return true;
                    }
                    else if (maxValue === 0 && minValue <= value) {
                        return true;
                    }
                    else if (minValue <= value && value <= maxValue) {
                        return true;
                    }
                }
                return false;
            }
        })) !== null && _b !== void 0 ? _b : [];
        return validFields.length === activeFields.length;
    },
    /****************************************************************************************
     * Publish validate
     ****************************************************************************************/
    validatePublish(event) {
        let eventSchema;
        const posterImageUrlSchema = joi_1.default.object({
            original: joi_1.default.string().required().messages({
                "string.empty": '"Event image" is a required field',
                "any.required": '"Event image" is a required field',
            }),
            medium: joi_1.default.string().allow('', null).optional(),
            small: joi_1.default.string().allow('', null).optional(),
        })
            .unknown(true)
            .required()
            .messages({
            "any.required": '"Event image" is a required field',
            "object.base": '"Event image" is a required field', // handles case when it's not an object
        });
        switch (event.type) {
            case IEvent_1.EventTypeEnum.GeneralEvent:
                eventSchema = joi_1.default.object()
                    .options({ abortEarly: false })
                    .keys({
                    name: joi_1.default.string()
                        .required()
                        .messages({ "string.empty": '"Event name" is a required field' }),
                    description: joi_1.default.string().required().messages({
                        "string.empty": '"Event description" is a required field',
                    }),
                    posterImageUrl: posterImageUrlSchema,
                    venueId: joi_1.default.string()
                        .required()
                        .messages({ "string.empty": '"Venue" is required' }),
                    ticketTypes: joi_1.default.array()
                        .min(1)
                        .items(joi_1.default.object()
                        .options({ allowUnknown: true })
                        .keys({
                        name: joi_1.default.string().required(),
                        remainingQty: joi_1.default.number().required(),
                        totalQty: joi_1.default.number().required(),
                        purchaseLimit: joi_1.default.number().required(),
                        tiers: joi_1.default.array().items(joi_1.default.object()
                            .keys({
                            name: joi_1.default.string().required(),
                            price: joi_1.default.number().required(),
                            remainingQty: joi_1.default.number().required(),
                            totalQty: joi_1.default.number().required(),
                        })
                            .unknown(true)),
                    }))
                        .messages({ "array.min": '"Event" must have atleast 1 ticket' }),
                })
                    .unknown(true);
                break;
            case IEvent_1.EventTypeEnum.Concert:
                eventSchema = joi_1.default.object()
                    .options({ abortEarly: false })
                    .keys({
                    name: joi_1.default.string()
                        .required()
                        .messages({ "string.empty": '"Event name" is a required field' }),
                    description: joi_1.default.string().required().messages({
                        "string.empty": '"Event description" is a required field',
                    }),
                    posterImageUrl: posterImageUrlSchema,
                    venueId: joi_1.default.string()
                        .required()
                        .messages({ "string.empty": '"Venue" is required' }),
                    performances: joi_1.default.array()
                        .items(joi_1.default.object()
                        .keys({
                        headliningArtistIds: joi_1.default.array()
                            .items(joi_1.default.string().required())
                            .messages({
                            "array.includesRequiredUnknowns": "An event performer is required for a concert",
                        }),
                    })
                        .unknown(true))
                        .default([]),
                })
                    .unknown(true);
                break;
        }
        return eventSchema.validate(event);
    },
    /****************************************************************************************
     * Ticket Hold  validate
     ****************************************************************************************/
    validateTicketHold(ticketHold) {
        let ticketHoldSchema;
        let used = ticketHold === null || ticketHold === void 0 ? void 0 : ticketHold.ticketRemaining;
        ticketHoldSchema = joi_1.default.object()
            .options({ abortEarly: false })
            .keys({
            name: joi_1.default.string()
                .required()
                .messages({ "string.empty": '"Block name" is a required field' }),
            ticketType: joi_1.default.string()
                .required()
                .messages({ "string.empty": '"Ticket Type" is a required field' }),
            qty: joi_1.default.number()
                .required()
                .min(1)
                .custom((value, helpers) => {
                if (value > 0 && value > used) {
                    return helpers.error("totalqty.invalid");
                }
                return value;
            })
                .messages({
                "totalqty.invalid": '"Total qty." must be less than or equal to the number of ticket remaining qty.',
                "number.min": '"Total qty." must be greater than 0',
            }),
        })
            .unknown(true);
        return ticketHoldSchema.validate(ticketHold);
    },
    validateTicketHoldName(ticketHold) {
        let ticketHoldSchema;
        ticketHoldSchema = joi_1.default.object()
            .options({ abortEarly: false })
            .keys({
            name: joi_1.default.string()
                .required()
                .messages({ "string.empty": '"Block name" is a required field' }),
        })
            .unknown(true);
        return ticketHoldSchema.validate(ticketHold);
    },
    /****************************************************************************************
     * Ticket validate
     ****************************************************************************************/
    validateTicket(ticket, isPaid, isMultipleDays) {
        let ticketSchema;
        let limit = isPaid ? "Purchase limit" : "RSVP limit";
        let used = ticket.totalQty - ticket.remainingQty;
        ticketSchema = joi_1.default.object()
            .options({ abortEarly: false })
            .keys({
            name: joi_1.default.string()
                .required()
                .messages({ "string.empty": '"Ticket name" is a required field' }),
            remainingQty: joi_1.default.number().required(),
            totalQty: joi_1.default.number().required().min(1).messages({
                "number.required": '"Total qty." is a required field',
                "number.min": '"Total qty." must be greater than 0',
            }),
            purchaseLimit: joi_1.default.number()
                .required()
                .min(1)
                .messages({
                "number.required": `"${limit}" is a required field`,
                "number.min": `"${limit}" must be greater than 0`,
                "number.base": `"${limit}" must be a number`,
            }),
            dayIds: joi_1.default.array()
                .min(isMultipleDays ? 1 : 0)
                .items(joi_1.default.string())
                .default([])
                .messages({
                "array.min": "Ticket must have selected atleast one day.",
            }),
            tiers: joi_1.default.array()
                .items(joi_1.default.object()
                .keys({
                name: joi_1.default.string().required().messages({
                    "string.empty": '"Tier name" is a required field',
                    "any.required": '"Tier name" must be provided',
                }),
                price: joi_1.default.number().required(),
                remainingQty: joi_1.default.number().required(),
                totalQty: joi_1.default.number()
                    .custom((value, helpers) => {
                    if (value > 0 && value < used) {
                        return helpers.error("totalqty.invalid");
                    }
                    return value;
                })
                    .messages({
                    "totalqty.invalid": '"Total qty." must be greater than or equal to number of ticket sold',
                })
                    .required(),
                startsAt: joi_1.default.date().allow(null),
                endsAt: joi_1.default.date().allow(null),
            })
                .unknown(true))
                .custom((tiers, helpers) => {
                // Only validate active tiers
                const activeTiers = tiers.filter(t => t.isActive !== false);
                for (let i = 0; i < activeTiers.length; i++) {
                    const tier = activeTiers[i];
                    if (tier.startsAt && tier.endsAt) {
                        const start = new Date(tier.startsAt);
                        const end = new Date(tier.endsAt);
                        if (isNaN(start.getTime()) || isNaN(end.getTime())) {
                            return helpers.error("tiers.invalidDate", { index: i + 1 });
                        }
                        if (end.getTime() <= start.getTime()) {
                            const tierLabel = tier.name && tier.name.trim() !== ""
                                ? ` "${tier.name}"`
                                : ` #${i + 1}`;
                            return helpers.error("tiers.endsAtBeforeStartsAt", {
                                tierLabel,
                            });
                        }
                    }
                }
                for (let i = 1; i < activeTiers.length; i++) {
                    const prevTier = activeTiers[i - 1];
                    const currentTier = activeTiers[i];
                    const prevEndsAt = new Date(prevTier.endsAt).getTime();
                    const currStartsAt = new Date(currentTier.startsAt).getTime();
                    if (currStartsAt !== prevEndsAt) {
                        // TODO Return custom error
                        return helpers.error("tiers.startsAtMismatch", {
                            index: i + 1,
                        });
                    }
                }
                return tiers;
            })
                .messages({
                "tiers.startsAtMismatch": "Start date/time of Tier {#index} must match end date/time of previous tier.",
                "tiers.endsAtBeforeStartsAt": "End date/time of Tier{#tierLabel} must be after start date/time.",
            }),
        })
            .unknown(true);
        return ticketSchema.validate(ticket);
    },
    /****************************************************************************************
     * Upgrade  validate
     ****************************************************************************************/
    validateUpgrade(upgrade, isPaid) {
        let upgradeSchema;
        let limit = isPaid ? "Purchase limit" : "RSVP limit";
        let used = upgrade.totalQty - upgrade.remainingQty;
        upgradeSchema = joi_1.default.object()
            .options({ abortEarly: false })
            .keys({
            name: joi_1.default.string()
                .required()
                .messages({ "string.empty": '"Upgrade name" is a required field' }),
            price: joi_1.default.number().required(),
            totalQty: joi_1.default.number()
                .custom((value, helpers) => {
                if (value > 0 && value < used) {
                    return helpers.error("totalqty.invalid");
                }
                return value;
            })
                .messages({
                "totalqty.invalid": '"Total qty." must be greater than or equal to number of upgrade sold',
            })
                .required()
                .min(1)
                .messages({
                "number.required": '"Total qty." is a required field',
                "number.min": '"Total qty." must be greater than 0',
            }),
            remainingQty: joi_1.default.number(),
            purchaseLimit: joi_1.default.number()
                .required()
                .min(1)
                .messages({
                "number.required": `"${limit}" is a required field`,
                "number.min": `"${limit}" must be greater than 0`,
                "number.base": `"${limit}" must be a number`,
            }),
            complimentary: joi_1.default.boolean().required(),
            complimentaryWith: joi_1.default.string().required(),
            complimentaryQty: joi_1.default.number().required(),
            ticketTypeIds: joi_1.default.array().items(joi_1.default.string()).default([]),
            imageUrl: joi_1.default.string().optional().allow(""),
            description: joi_1.default.string().optional().allow(""),
            visible: joi_1.default.boolean().required(),
            rollFees: joi_1.default.boolean().required(),
        })
            .unknown(true);
        return upgradeSchema.validate(upgrade);
    },
    /****************************************************************************************
     * Promotion  validate
     ****************************************************************************************/
    validatePromotion(promotion) {
        let promotionSchema;
        let used = promotion.totalQty - promotion.remainingQty;
        promotionSchema = joi_1.default.object()
            .options({ abortEarly: false })
            .keys({
            code: joi_1.default.string()
                .required()
                .messages({ "string.empty": '"Secret code" is a required field' }),
            type: joi_1.default.string().required(),
            remainingQty: joi_1.default.number(),
            totalQty: joi_1.default.number()
                .custom((value, helpers) => {
                if (value > 0 && value < used) {
                    return helpers.error("totalqty.invalid");
                }
                return value;
            })
                .messages({
                "totalqty.invalid": '"Total qty." must be greater than or equal to number of secret code sold',
            })
                .required()
                .min(1)
                .messages({
                "number.required": '"Total qty." is a required field',
                "number.min": '"Total qty." must be greater than 0',
            }),
            ticketTypeIds: joi_1.default.array().items(joi_1.default.string()).default([]),
            upgradeIds: joi_1.default.array().items(joi_1.default.string()).default([]),
            active: joi_1.default.boolean().required(),
            startsAt: joi_1.default.number().required(),
            endsAt: joi_1.default.number().required(),
            useLimit: joi_1.default.number().min(1).messages({
                "number.required": '"Use limit" is a required field',
                "number.min": 'Use limit" must be greater than 0',
                "number.base": '"Use limit" must be a number',
            }),
            discountType: joi_1.default.string(),
            discountValue: joi_1.default.number(),
        })
            .unknown(true);
        return promotionSchema.validate(promotion);
    },
    /****************************************************************************************
     *Validate Event EmailSubject & EmailBody
     ****************************************************************************************/
    ValidateEventEmailSubjectFields(emailPreviewFields) {
        const isEmptyHTML = (value) => {
            return (!value ||
                value.trim() === "" ||
                value.trim() === "<p></p>" ||
                value.trim() === "<p><br></p>");
        };
        let validateEmailPreviewFields = joi_1.default.object()
            .options({ abortEarly: false })
            .keys({
            eventEmailSubject: joi_1.default.string().required().messages({
                "string.empty": "Email Subject cannot be empty",
                "any.required": "Email Subject is required",
            }),
            eventEmailBody: joi_1.default.string()
                .custom((value, helpers) => {
                if (isEmptyHTML(value)) {
                    return helpers.error("string.empty");
                }
                return value;
            })
                .required()
                .messages({
                "string.empty": "Email Body cannot be empty",
                "any.required": "Email Body is required",
            }),
        })
            .unknown(true);
        return validateEmailPreviewFields.validate(emailPreviewFields);
    },
    /****************************************************************************************
     * CustomField  validate
     ****************************************************************************************/
    validateCustomField(customField) {
        let customFieldSchema;
        customFieldSchema = joi_1.default.object()
            .options({ abortEarly: false })
            .keys({
            label: joi_1.default.string()
                .required()
                .messages({ "string.empty": '"Question" is a required field' }),
            type: joi_1.default.string().required(),
            // minLength: Joi.number(),
            // maxLength: Joi.number(),
            // minValue: Joi.number(),
            // maxValue: Joi.number(),
            options: joi_1.default.array().items(joi_1.default.string()).default([]),
            required: joi_1.default.boolean().required(),
            active: joi_1.default.boolean().required(),
        })
            .unknown(true);
        return customFieldSchema.validate(customField);
    },
    validateRefundModal(refundField) {
        let refundFieldSchema;
        refundFieldSchema = joi_1.default.object()
            .options({ abortEarly: false })
            .keys({
            // ticketIds: Joi.array()
            //   .min(1)
            //   .items(Joi.string())
            //   .messages({ "array.min": "Select any one checkbox for refunding." }),
            refundReason: joi_1.default.string()
                .required()
                .messages({ "string.empty": '"Reason" is a required field' }),
        })
            .unknown(true);
        return refundFieldSchema.validate(refundField);
    },
    validateEventDates(event) {
        var _a, _b, _c, _d, _e, _f, _g;
        const schedule = event === null || event === void 0 ? void 0 : event.schedule;
        const announceAt = schedule === null || schedule === void 0 ? void 0 : schedule.announceAt;
        const ticketsAt = schedule === null || schedule === void 0 ? void 0 : schedule.ticketsAt;
        const ticketsEndAt = schedule === null || schedule === void 0 ? void 0 : schedule.ticketsEndAt;
        const performance = (_a = event === null || event === void 0 ? void 0 : event.performances) === null || _a === void 0 ? void 0 : _a[0];
        const startsAt = ((performance === null || performance === void 0 ? void 0 : performance.schedule) &&
            ((_b = performance === null || performance === void 0 ? void 0 : performance.schedule[0]) === null || _b === void 0 ? void 0 : _b.startsAt)) ||
            0;
        const endsAt = ((_c = event === null || event === void 0 ? void 0 : event.totalDays) === null || _c === void 0 ? void 0 : _c.length) === 0
            ? (_d = event === null || event === void 0 ? void 0 : event.schedule) === null || _d === void 0 ? void 0 : _d.endsAt
            : ((performance === null || performance === void 0 ? void 0 : performance.schedule) &&
                ((_f = performance === null || performance === void 0 ? void 0 : performance.schedule[((_e = performance === null || performance === void 0 ? void 0 : performance.schedule) === null || _e === void 0 ? void 0 : _e.length) - 1]) === null || _f === void 0 ? void 0 : _f.endsAt)) ||
                0;
        /* Actions */
        let message = "";
        (_g = performance === null || performance === void 0 ? void 0 : performance.schedule) === null || _g === void 0 ? void 0 : _g.some((a, i) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            if (a.startsAt < a.doorsAt) {
                message =
                    (performance === null || performance === void 0 ? void 0 : performance.schedule) && ((_a = performance === null || performance === void 0 ? void 0 : performance.schedule) === null || _a === void 0 ? void 0 : _a.length) > 1
                        ? "Doors Open should be less than or equal to Event Begins on day " +
                            (i + 1) +
                            "."
                        : "Doors Open should be less than or equal to Event Begins.";
                return message;
            }
            else if (a.startsAt >
                (((_b = event === null || event === void 0 ? void 0 : event.totalDays) === null || _b === void 0 ? void 0 : _b.length) === 0
                    ? (_c = event === null || event === void 0 ? void 0 : event.schedule) === null || _c === void 0 ? void 0 : _c.endsAt
                    : a.endsAt)) {
                message =
                    (performance === null || performance === void 0 ? void 0 : performance.schedule) && ((_d = performance === null || performance === void 0 ? void 0 : performance.schedule) === null || _d === void 0 ? void 0 : _d.length) > 1
                        ? "Event Ends should be greater than Event Begins on day " +
                            (i + 1) +
                            "."
                        : "Event Ends should be greater than Event Begins.";
                return message;
            }
            else if ((performance === null || performance === void 0 ? void 0 : performance.schedule) && ((_e = performance === null || performance === void 0 ? void 0 : performance.schedule) === null || _e === void 0 ? void 0 : _e.length) > 1) {
                const aa = ((_g = (_f = performance === null || performance === void 0 ? void 0 : performance.schedule) === null || _f === void 0 ? void 0 : _f[i + 1]) === null || _g === void 0 ? void 0 : _g.startsAt) &&
                    ((_j = (_h = performance === null || performance === void 0 ? void 0 : performance.schedule) === null || _h === void 0 ? void 0 : _h[i + 1]) === null || _j === void 0 ? void 0 : _j.startsAt) >
                        (((_k = event === null || event === void 0 ? void 0 : event.totalDays) === null || _k === void 0 ? void 0 : _k.length) === 0
                            ? (_l = event === null || event === void 0 ? void 0 : event.schedule) === null || _l === void 0 ? void 0 : _l.endsAt
                            : a.endsAt);
                if (!aa && aa !== undefined) {
                    message =
                        "Day " +
                            (i + 2) +
                            " Event Begins should be greater than day " +
                            (i + 1) +
                            " Event Ends.";
                    return message;
                }
            }
        });
        if (announceAt > startsAt) {
            message = "Announcement Date should be less than Event Begins.";
            return message;
        }
        else if (ticketsAt < announceAt || ticketsAt > ticketsEndAt) {
            message =
                "Sales Begin should be greater than or equal to Announcement Date and less than Sales End.";
            return message;
        }
        else if (ticketsEndAt > endsAt) {
            message = "Sales End should be less than or equal to Event Ends.";
            return message;
        }
        return message;
    },
};
//# sourceMappingURL=EventUtil.js.map